import { shouldRecordTraces } from "../../shared/utilities";
import {
    TraceEvent
} from "./types";

export function addTraceEvent(event: TraceEvent) {
    if (!shouldRecordTraces()) return;

    if (!window["__TRACE_EVENTS__"]) {
        window["__TRACE_EVENTS__"] = [];
    }

    window["__TRACE_EVENTS__"].push({
        timestamp: new Date(),
        event
    });
}